import { Line } from 'react-chartjs-2'
import { ChartProvider, LoadingFit, PageHeader } from '../../share/Components'
import classes from "./ManagementDashboard.module.scss";
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import DateFilter from './Items/DateFilter'
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { ReducerType } from '../../storeManager/ReducerType';
import { LoginInterface } from '../../Interfaces/LoginInterface';
import useFetch from '../../_services/fetch';
import { RaytebRequests } from '../../_services';
const VisitReport = () => {
  const [labels, setLabels] = useState<Array<string>>([]);
  const [values, setValues] = useState<Array<number>>([]);
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  );
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const dateFilter = useSelector<ReducerType, DateFilterViewModel>(
    (state) => state.reducerDateFilter
  );

  const { isLoading, reFetch } = useFetch<
    Array<ManagementDataPerDateViewModel<number>>,
    unknown,
    { to?: Date; from?: Date }
  >({
    request: RaytebRequests.Management_GetVisitCount_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      setLabels(data.map((item) => new Date(item.date).toShamsi()));
      setValues(data.map((item) => item.value));
    },
  });
  useEffect(() => {
    reFetch(null, {
      from: dateFilter?.from,
      to: dateFilter?.to,
    });
  }, [dateFilter]); // eslint-disable-line react-hooks/exhaustive-deps
  //const labels = ["بلا", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر"

  const data = {
    labels,
    datasets: [
      {
        label: "تعداد ویزیت",
        data: values,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };
  return (
    <>
      <LoadingFit isLoading={isLoading}></LoadingFit>
      <PageHeader title="داشبورد مدیریتی / تعداد ویزیت" />
      <div className={classes["report-dashboard"]}>
        <div className={classes["filters"]}>
          <DateFilter />
        </div>
        <div className={classes["items"]}>
          <ChartProvider
            listChart={[
              CategoryScale,
              LinearScale,
              PointElement,
              LineElement,
              Title,
              Tooltip,
              Legend,
            ]}
          >
            <Line data={data} />
          </ChartProvider>
        </div>
      </div>
    </>
  );
}
export default VisitReport
